import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function Inscription() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [loading, setLoading] = useState(false)
  const [erreur, setErreur] = useState('')
  const [succes, setSucces] = useState(false)

  const inscrire = async (e) => {
    e.preventDefault()
    setErreur('')
    if (password !== confirm) return setErreur('Les mots de passe ne correspondent pas.')
    if (password.length < 8) return setErreur('Le mot de passe doit faire au moins 8 caractères.')
    setLoading(true)
    const { error } = await supabase.auth.signUp({ email, password })
    setLoading(false)
    if (error) return setErreur(error.message === 'User already registered' ? 'Cet email est déjà utilisé.' : 'Erreur : ' + error.message)
    setSucces(true)
  }

  if (succes) return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={{ fontSize: 56, textAlign: 'center', marginBottom: 16 }}>📬</div>
        <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 24, fontWeight: 900, color: '#1a2e5a', textAlign: 'center', marginBottom: 12 }}>
          Vérifie tes emails !
        </h2>
        <p style={{ color: '#6b7280', textAlign: 'center', lineHeight: 1.6 }}>
          Un lien de confirmation a été envoyé à <strong>{email}</strong>.<br/>Clique dessus pour activer ton compte.
        </p>
        <button onClick={() => navigate('/connexion')} style={{ ...btnStyle, marginTop: 24 }}>
          Aller à la connexion
        </button>
      </div>
    </div>
  )

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>⭐</div>
          <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 26, fontWeight: 900, color: '#1a2e5a', margin: 0 }}>
            Créer un compte
          </h1>
          <p style={{ color: '#6b7280', fontSize: 14, marginTop: 6 }}>Compte parent KudoGenius</p>
        </div>

        <form onSubmit={inscrire} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div>
            <label style={labelStyle}>Adresse email</label>
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)}
              className="input" placeholder="ton@email.com" />
          </div>
          <div>
            <label style={labelStyle}>Mot de passe</label>
            <input type="password" required value={password} onChange={e => setPassword(e.target.value)}
              className="input" placeholder="Minimum 8 caractères" />
          </div>
          <div>
            <label style={labelStyle}>Confirmer le mot de passe</label>
            <input type="password" required value={confirm} onChange={e => setConfirm(e.target.value)}
              className="input" placeholder="Répète le mot de passe" />
          </div>

          {erreur && <div style={{ background: '#FEE2E2', color: '#DC2626', borderRadius: 10, padding: '10px 14px', fontSize: 14, fontWeight: 700 }}>{erreur}</div>}

          <button type="submit" disabled={loading} style={btnStyle}>
            {loading ? 'Création...' : 'Créer mon compte'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: 20, color: '#6b7280', fontSize: 14 }}>
          Déjà un compte ? <Link to="/connexion" style={{ color: '#2d7dd2', fontWeight: 800 }}>Se connecter</Link>
        </p>
        <p style={{ textAlign: 'center', marginTop: 16, color: '#9ca3af', fontSize: 11 }}>
          🔒 Aucune donnée personnelle de l'enfant n'est demandée<br/>
          Un outil offert par <a href="https://nutrygenius.com" target="_blank" rel="noreferrer" style={{ color: '#2d7dd2' }}>NutryGenius®</a>
        </p>
      </div>
    </div>
  )
}

const containerStyle = {
  minHeight: '100vh', background: '#f0f6ff',
  display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20
}
const cardStyle = {
  background: '#fff', borderRadius: 24, padding: '40px 36px',
  maxWidth: 440, width: '100%',
  boxShadow: '0 8px 40px rgba(45,125,210,0.12)',
  border: '1px solid #dbeafe'
}
const btnStyle = {
  width: '100%', padding: '14px', borderRadius: 30, border: 'none',
  background: '#2d7dd2', color: '#fff', fontSize: 16, fontWeight: 800,
  cursor: 'pointer', fontFamily: "'Nunito', sans-serif",
  boxShadow: '0 4px 15px rgba(45,125,210,0.3)'
}
const labelStyle = { display: 'block', fontSize: 13, fontWeight: 800, color: '#374151', marginBottom: 6 }
